import LogoIcon from "../../public/images/Logo.svg";
import LogoSynerpa2021RVB from "../../public/images/SYNERPALOGOCOULEURRVB.png";
import { IconButton, IconButtonProps } from "@mui/material";
import { useAuth } from "../../hooks";
import { RoutesEnum } from "../../router/routes";

const Logo = (
    props: IconButtonProps & {
        customwidth?: string;
        gap?: string;
    }
) => {
    const { isAuthenticated } = useAuth();

    return (
        <IconButton
            {...props}
            sx={{
                gap: "3.543rem",
                "@media (min-width: 600px) and (max-width:1470px)": {
                    gap: "0.5rem",
                },

                "&:hover": {
                    backgroundColor: "#FFF",
                },
            }}
            onClick={() =>
                window.location.replace(
                    isAuthenticated()
                        ? `/${RoutesEnum.monespace}`
                        : `/${RoutesEnum.login}`
                )
            }
        >
            <img src={LogoIcon} alt="Logo" width={"88"} height="89" />
            <img
                src={LogoSynerpa2021RVB}
                alt="LogoSynerpa"
                width="130"
                height="89"
            />
        </IconButton>
    );
};

export default Logo;
